<template>
  <!-- 左侧菜单动态渲染模板文件 慎改！-->
    <fragment>
      <template v-for="menu in menuTree">
        <el-submenu v-if="menu.children && menu.children.length > 0" :key="menu.id" :index="menu.id.toString()" >
          <template slot="title">
            <i :class="menu.css"></i>
            <span :title="menu.translation ? $t(menu.translation) : menu.name">
              {{menu.translation ? $t(menu.translation) : menu.name}}
            </span>
          </template>
          <LeftNavOfSpm :menuTree="menu.children"></LeftNavOfSpm>
        </el-submenu>
        <el-menu-item-group v-else :key="menu.id">
          <el-menu-item :index="menuUrlRewrite(menu)" :key="menu.id" v-if="menu.isMatched && menu.showInMenu !== false">
            <span>
              <Tooltips effect="dark" :text="menu.translation ? $t(menu.translation) : menu.name" placement="top">
                {{menu.translation ? $t(menu.translation) : menu.name}}
              </Tooltips>
            </span>
            <i class="el-icon-star-on" :class="{'collected': collectMenus.find(item => item.url === menu.url )}"  @click.stop.prevent="handleToggleCollect(menu)"></i>
          </el-menu-item>
        </el-menu-item-group>
      </template>
    </fragment>
</template>

<script>
import API from '@/api'
import Tooltips from './components/ToolTips.vue'
export default {
  name: 'LeftNavOfSpm',
  props:  {
    menuTree: {
      type: Array,
      required: true,
      default: ()=>{
        return []
      }
    }
  },
  components: {
    Tooltips
  },
  data () {
    return {
    
    }
  },
  computed: {
    // 获取收藏的菜单
    collectMenus() {
      return this.$store.state.appStore.collectMenus || []
    }
  },
  methods: {
    // 打开子页面
    async openChildPage (name, params) {
      this.$router.push({ 'name': name, 'params': params })
    },
    // 切换菜单选中状态
    async handleToggleCollect(item) {
      const index = this.collectMenus.findIndex(menu => menu.id === item.id)
      const params = item
      let addFlag = true
      if(index !== -1) {
        const code = item && item.code
        const result = await API.cancelFavoriteMenu({'code':code})
        if(result.data && result.data.resultCode == 1){
          this.collectMenus.splice(index, 1)
          addFlag = false
          this.handleConfrim(addFlag)
        }else{
          this.$message.error(this.$t(result.data.resultCode));
        }
      } else {
        if(this.collectMenus.length >= 10){
          return this.$notify.warning({
            title: this.$t('tips'),
            message: this.$t('quickEntranceMax10')
          })
        }
        const res = await API.addFavoriteMenu(params)
        if(res.data && res.data.resultCode == 1){
          this.collectMenus.push(item)
          addFlag = true
          this.handleConfrim(addFlag)
        }else{
          this.$message.error(this.$t(res.data.resultCode));
        }
      }
    },
    // 存入store
    async handleConfrim(addFlag) {
      try {
        this.$notify.success({
          title: this.$t('success'),
          message: addFlag ? this.$t('quickEntranceAddSuccessed') : this.$t('quickEntranceDeleteSuccessed')
        })
        this.$store.commit('SET_COLLECT_MENUS', this.collectMenus)
      } catch (error) {
        console.log('出现异常', error)
      }
    },
    // 菜单被重写 解决菜单不跳转对应页面问题
    menuUrlRewrite(menu) {
      if (menu.url === '/customRecheckMixedGoods') {
        return menu.baseUrl || '/customRecheck'
      }
      return menu.url
    }
  }
}
</script>

<style lang="scss" scoped>
  @mixin icon{
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-right: 6px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .el-menu{
    height: 100%;
    border-right: none!important;
    flex: none;
  }
  .el-menu-item.is-active{
    background: rgba(60,110,240,0.1) !important;
    color: #3C6EF0!important;
  }

  .appointment{
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/231258/21/6331/1106/656e9efeF0323626e/38c2ca7def7f689f.png");
  }
  .acceptance {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/236808/26/5566/1394/656e9efeF6fbafb5a/ecf53e59c9c17e70.png");
  }
  .putaway {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/233373/35/5945/883/656e9f03F3cde3fe5/17c5193f7a173932.png");
  }
  .return {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/225935/34/6243/1210/656e9f03F25b966a8/f4b69d82a88a673a.png");
  }
  .positioning {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/235798/33/5668/1735/656e9f02Fa740e7c1/b3860a6bf190d656.png");
  }
  .task-assignment {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/236255/37/5864/1098/656e9f04Faa250691/0396f5662820750d.png");
  }
  .picking {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/217835/18/29574/1195/656e9f02F3d9a0929/ce7a25f634679072.png");
  }
  .recheck {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/237842/33/5922/1693/656e9f03F6ccf6328/7fe8aa06a5a913a1.png");
  }
  .handover {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/226870/6/6379/1793/656e9effF4fc6e382/1f20e174c5c90a2c.png");
  }
  .inventory-check {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/237547/31/5995/1171/656e9f00F6ecb6a1a/b612cac3cace2d80.png");
  }
  .vas {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/231333/23/6196/1908/656e9f04F3a3c2f21/a4b4b6172d300700.png");
  }
  .ownership-transfer{
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/230639/26/6096/1707/656e9f02Fa70235e0/ceb90ac5939c3437.png");
  }
  .difference-center {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/228358/3/5439/1528/656e9effF5533eb91/a07b70025f8b0f9c.png");
  }
  .maintenance {
    @include icon;
    background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/230538/32/6205/1718/656e9f00F2de20b3b/dff6cb221fd45e9b.png");
  }
  .trans {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/224777/22/6026/1316/656e9f03F01607006/5ce17bfb14a151d1.png");
  }
  .warehouse {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/117421/23/39069/859/656e9f04Fe86c498c/cbb9ab83b5b70f8a.png");
  }
  .customer-mgmt {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/195447/9/41029/1509/656e9effFb9e83f87/7a1b51693a3bf23b.png");
  }
  .system-config {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/228246/30/6266/1477/656e9f04F286d65ca/28d009ce3909c9d6.png");
  }
  .sku {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/228048/38/6252/1277/656e9f03Fa148600d/a8f95f81766672c1.png");
  }
  .inbound {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/233084/12/5948/1225/656e9f00F6fae874e/f781dc611ec340fd.png");
  }
  .outbound {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/234254/2/5639/1256/656e9f01Fe6eeb799/bab6a03173489ec2.png");
  }
  .on-hand {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/227284/39/6489/859/656e9f01F9ab9bbeb/e0be50f694d075f9.png");
  }
  .inventory-qry {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/227906/35/6452/1178/656e9f00Fda1b3f50/c8da1284513d8a69.png");
  }
  .exception {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/226184/35/6200/1065/656e9f04F1e0b6b87/e0564bcc13f0af2d.png");
  }
  .doc-print {
    @include icon;
    background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/235453/4/5937/1266/656e9f00F92c85b8a/8d5e89eee09c5b0b.png");
  }
  .basic-print {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/233199/23/6182/1142/656e9effF39ff2155/af2a12bc8bbb859a.png");
  }
  .print-setting {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/119628/19/35554/1403/656e9f02F40097b12/20c2d2f5650b5e7e.png");
  }
  .replenishment {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/228631/3/6148/1546/656e9f03F60f31cfd/f6120a4fd67fcebf.png");
  }
  .handover-su {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/317412/35/14259/2192/686b9f67F1c099f00/828578fb414129be.png");
  }
  .pack-su {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/319689/22/14546/2712/686c80f9Ffe9c3c6e/3cbf836d105e6dfe.png");
  }
  .rebin-su {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/294635/31/15670/1429/686c8113F5df3d0f1/82d99e9548663943.png");
  }
  .picking_su {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/295728/10/20105/1666/686c8104Fbc9f76ff/b25603fb8b344fd6.png");
  }
  .sorting_su {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/310341/28/15299/1857/686c811dF070f2280/a7920a206ea7ffc1.png");
  }
  .unload-su {
    @include icon;
    background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/309234/34/17978/7047/68809838F30321fdb/d37c60a624b94962.png");
  }
  .receive_su {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/321472/2/18486/5608/68809838F70932794/73d1e463b32bddf6.png");
  }
  .putAway_su {
    @include icon;
    background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/314502/3/19328/4747/68809837F55b01270/c0654b6f640dc81f.png");
  }
  .check_su {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/323824/26/10728/8781/68ac5ab4F8a82f17a/d186ae3a6af4b20b.png");
  }
  .anomaly-assignment {
    @include icon;
    background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/409601/30/735/817/69c25b74F4df929ff/03e6020020298c31.png");
  }
  .container_su {
    @include icon;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/409923/4/18205/1183/69cbc718F38a14d21/03e6030030d21c89.png");
  }
  .is-opened{
    .appointment{
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/221982/11/35879/1292/656e9efeF7e557d52/6fb0bb3a95e32a8b.png");
    }
    .acceptance {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/226804/19/6068/1144/656e9efeFfcdd996b/cc5386f1d4e8beed.png");
    }
    .putaway {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/233627/13/5928/1143/656e9f03Fa5748c82/9ab48fb9ccf4abc1.png");
    }
    .return {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/184664/40/41242/1132/656e9f03F4bff2a63/9a6084a0cd5bf400.png");
    }
    .positioning {
      @include icon;
      background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/229294/9/5638/1214/656e9f02F4e220e3a/2036c01867bc2bcc.png");
    }
    .task-assignment {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/231836/39/6423/1078/656e9f04Fa8fdfd15/903b716b15407e92.png");
    }
    .picking {
      @include icon;
      background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/232046/10/6235/1124/656e9f02Fe824f739/8c8df6cdf83ba354.png");
    }
    .recheck {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/232040/6/6198/1915/656e9f03F229f2068/c686f5d92ad0aa4c.png");
    }
    .handover {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/231583/33/6045/1605/656e9effFd2278005/64e62c610d87ab06.png");
    }
    .inventory-check {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/227920/19/6292/952/656e9f00F0c14099f/1219870f3e67f237.png");
    }
    .vas {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/225761/5/6117/1448/656e9f04Fa6386a9c/d6e62050d9eba4c3.png");
    }
    .ownership-transfer{
      @include icon;
      background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/234400/26/6305/1835/656e9f02F2214bdc4/59632ffdb154b96c.png");
    }
    .difference-center {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/234333/12/6090/1254/656e9effF0106d8fc/fffe4a8cf8d36460.png");
    }
    .maintenance {
      @include icon;
      background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/238359/34/5669/1437/656e9f01Fa591fbb6/1ea2e7c4e8505b86.png");
    }
    .trans {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/226086/39/4839/1245/656e9f03F8ea6d5a1/0f394d5ca5d0ae41.png");
    }
    .warehouse {
      @include icon;
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/116044/12/43210/761/656e9f04F62711184/eca44dc9f4abdcca.png");
    }
    .customer-mgmt {
      @include icon;
      background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/235922/23/5225/1100/656e9effF968250fd/2d1142d0e87cbf9a.png");
    }
    .system-config {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/231913/6/6171/1297/656e9f04Fb90389a5/08562b88a5acb66e.png");
    }
    .sku {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/227745/20/6480/1445/656e9f04Ff735f3c9/b349d12d57d51b47.png");
    }
    .inbound {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/228184/11/6481/1032/656e9f00F5a5028e0/4bbcbc500cea1784.png");
    }
    .outbound {
      @include icon;
      background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/235619/31/5652/1028/656e9f02F0f16814a/da7dfbfe8a2cc861.png");
    }
    .on-hand {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/224442/14/6389/761/656e9f01F7aa7817a/6cbd0d7cdbfd3f05.png");
    }
    .inventory-qry {
      @include icon;
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/229342/17/6203/1259/656e9f00F5cc087e6/3c587fb203bd360b.png");
    }
    .exception {
      @include icon;
      background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/216227/22/33874/782/656e9f04F887eafa5/5d961b013f98a26c.png");
    }
    .doc-print {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/194420/9/41586/1077/656e9f00F8babf35a/d3232462a30d5382.png");
    }
    .basic-print {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/232003/6/6268/914/656e9effF4495bd48/8cdd19ccee2aff36.png");
    }
    .print-setting {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/231217/25/6145/952/656e9f02F3b029b44/16ed038ee5f22f26.png");
    }
    .replenishment {
      @include icon;
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/237376/6/5831/1836/656e9f03F8cacdf7c/9b6aa902ce902a15.png");
    }
    .handover-su {
      @include icon;
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/314597/14/14884/1645/686b9f62F5f36f06b/6ba0d55b3564d5b0.png");
    }
    .pack-su {
      @include icon;
      background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/307123/10/15174/2221/686c80f2F83a90985/e90fc0b11b84b8b8.png");
    }
    .rebin-su {
      @include icon;
      background-image: url("https://img14.360buyimg.com/imagetools/jfs/t1/310720/6/15328/1386/686c810bF4416a27b/0f0b2a4ae91d1a3e.png");
    }
    .picking_su {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/290284/34/20170/1287/686c80ffF47f47ada/7b5333c6a0503325.png");
    }
    .sorting_su {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/313629/9/15365/1357/686c8118F1857b3a2/6c254bb47f51a699.png");
    }
    .unload-su {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/297852/4/22991/7153/68809837F0ec1fc00/24398654ea3d8beb.png");
    }
    .receive_su {
      @include icon;
      background-image: url("https://img11.360buyimg.com/imagetools/jfs/t1/315967/4/19283/5659/68809838F7b662b38/afa569aada390dbf.png");
    }
    .putAway_su {
      @include icon;
      background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/294947/34/14096/4728/68809837Fd9a0fbf4/9b3fbd46cd6460bd.png");
    }
    .check_su {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/327863/8/10807/8797/68ac5ab4F2e32e8be/300c18787c7a3e59.png");
    }
    .anomaly-assignment {
      @include icon;
      background-image: url("https://img13.360buyimg.com/imagetools/jfs/t1/408194/2/5545/820/69c25b74Fe45facd5/03e602002020327c.png");
    }
    .container_su {
      @include icon;
      background-image: url("https://img10.360buyimg.com/imagetools/jfs/t1/412540/27/3129/1176/69cbc718Fc384ac26/03e6030030c4330f.png");
    }
  }
</style>
<style lang="scss" scoped>
.el-submenu {
  border-radius: 6px;
  /deep/ .el-submenu__title {
    border-radius: 6px;
    padding-left: 15px !important;
    .el-submenu__icon-arrow {
      right: 6px;
    }
    &:hover{
      background: rgba(245,245,246,1) !important;
    }
  }
}
/deep/ .el-menu-item {
  border-radius: 6px;
  min-height: 40px;
  height: auto !important;
  line-height: 1.4 !important;
  padding: 8px 20px 8px 20px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  display: flex !important;
  align-items: flex-start !important;
  position: relative;
  
  span {
    flex: 1;
    padding-right: 24px;
    word-wrap: break-word;
    white-space: normal !important;
    line-height: 1.4;
  }
  
  .el-icon-star-on {
    font-size: 20px;
    line-height: 24px;
    color: #D2D2D2;
    position: absolute;
    right: 6px;
    top: 8px;
    display: none;
    flex-shrink: 0;
    &.collected {
      color: #FECB52;
      display: block;
    }
  }
  &:hover {
    background: rgba(245,245,246,1);
    color: #525765;
    .el-icon-star-on {
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &.is-active {
    border: none;
    color: #3C6EF0;
    background: rgba(60,110,240,0.1) !important;
  }
}
</style>